export default (($) => {
    console.log('UNTUCKit : Module : Form : loaded');
    const formSubmitted = function () {
        if (window.location.hash.indexOf('#contact_form') > 0) {
            $('#contact_form').attr('id', '');
        }
        $('#contact_form').attr('action', '/contact');
    };
    const bindUIActions = function () {
        $('.form-label-placeholder .form-input').not('select').on('focusin', function () {
            $(this).prev().fadeOut(100);
        }).on('focusout', function () {
            if (!$(this).val()) {
                $(this).prev().fadeIn(100);
            }
        });
    };
    function init() {
        console.log('UNTUCKit : Module : Form : init');
        bindUIActions();
        formSubmitted();
    }
    return { init };
})($);
